module.exports = __webpack_public_path__ + "static/media/brief-info.5a31825f.png";